module.exports = __webpack_public_path__ + "static/media/elements_section2_slide4.95a7c1e2.png";